import { ProviderResponse } from '@/app/models/providersResponse';
import { useListAllProviderByPeriodQuery } from '@/app/services/providerApi';
import PageTitle from '@/components/common/pageTitle';
import { usePeriod } from '@/context/PeriodContext';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Typography, useTheme } from '@mui/material';
import { grey, orange } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

function ProvidersBreadcrumb() {
  const { id: idParam } = useParams();
  const { selectedPeriod } = usePeriod();
  const id = Number(idParam);

  const { data: providerData } = useListAllProviderByPeriodQuery(selectedPeriod?.date as string, {
    skip: !selectedPeriod,
  });

  const selected: ProviderResponse | undefined = providerData?.find((item) => item.provider.id === id);

  const { t } = useTranslation(['provider', 'common']);
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box style={{ display: 'flex', flexDirection: 'column' }}>
      <Box>
        {id ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PageTitle
              title={t('providers')}
              sx={{ color: orange[600], mb: 1 }}
              onClick={() => navigate('/providers')}
            />
            <ArrowForwardIosIcon
              sx={{
                color: grey[600],
                height: theme.spacing(1.2),
                width: theme.spacing(1.2),
                mx: 1,
                mt: 2,
              }}
            />
            <Typography sx={{ textAlign: 'center', mt: 2 }} variant="h3">{`${selected?.provider.code}`}</Typography>
          </Box>
        ) : (
          <Box sx={{ mb: 4 }}>
            <PageTitle title={t('providers')} sx={{ mb: 0 }} />
          </Box>
        )}
      </Box>
      <Outlet />
    </Box>
  );
}
export default ProvidersBreadcrumb;
